import React from 'react';
import PropTypes from 'prop-types';

const ArrowLeftIcon = ({ className, color }) => (
  <svg
    className={className}
    width='18px'
    height='12px'
    viewBox='0 0 18 12'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
  >
    <g
      id='1-copy-22'
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
      transform='translate(-20.000000, -18.000000)'
      opacity='1'
    >
      <g
        id='arrow_left'
        transform='translate(20.000000, 18.000000)'
        fill={color}
        fillRule='nonzero'
      >
        <path
          d='M0.240740741,6.61995 L4.98148148,11.71995 C5.30322963,12.011748 5.91899259,12.13245 6.27777778,11.79495 C6.63194074,11.46213 6.62035556,10.81644 6.26851852,10.48245 L2.93518519,6.90105 L17.1111852,6.90105 C17.6019111,6.90105 18.0000741,6.49791 18.0000741,6.00105 C18.0000741,5.50419 17.6019111,5.10105 17.1111852,5.10105 L2.93518519,5.10105 L6.26851852,1.51965 C6.57174815,1.21146 6.62845926,0.54348 6.27777778,0.20715 C5.92823704,-0.12918 5.28936296,-0.021366 4.98148148,0.28215 L0.240740741,5.38215 C0.0787022222,5.556759 0,5.76183 0,6.0009 C0.00810192593,6.215652 0.0960651852,6.4641 0.240740741,6.61995 Z'
          id='Shape'
        />
      </g>
    </g>
  </svg>
);

ArrowLeftIcon.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
};

export default ArrowLeftIcon;



// WEBPACK FOOTER //
// ./src/icons/ArrowLeftIcon.js